import { render, staticRenderFns } from "./AddTrip.vue?vue&type=template&id=f67085d2&scoped=true&"
import script from "./AddTrip.vue?vue&type=script&lang=js&"
export * from "./AddTrip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f67085d2",
  null
  
)

export default component.exports